// extracted by css-extract-rspack-plugin
export default {"textOverflow":"jstOKcX_C3wVg8hE","active":"TVdtzPzWEf4W0owK"};